// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static/js/" + chunkId + "." + {"38":"5405dfce","321":"afae3ff5","486":"3e841e9a","550":"8ba251d0","720":"2121181a"}[chunkId] + ".js";
};